import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ChatPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="container mx-auto px-6 py-8">
        <div className="flex items-center space-x-4 mb-8">
          <Button variant="ghost" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-3xl font-bold" style={{ fontFamily: 'Outfit' }}>
            Chat
          </h1>
        </div>

        <Card className="p-8 text-center">
          <h3 className="text-xl font-semibold mb-4">Chat en Tiempo Real</h3>
          <p className="text-slate-600">
            La funcionalidad de chat estará disponible próximamente.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default ChatPage;